import http from '@/utils/http';

/**
 * 投标商机交接-分页查询-tr
 */
export function getList(data) {
    return http({
        url: '/api-lcrm/asset/transfer/opportunityBid/pageList',
        method: 'post',
        data
    });
};

/**
 * 投标商机交接-修改承接人-tr
 */
export function updateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/opportunityBid/update',
        method: 'post',
        data
    });
};

/**
 * 投标商机交接-批量保存/修改承接人-tr
 */
export function batchUpdateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/opportunityBid/batchUpsert',
        method: 'post',
        data
    });
};

/**
 * 导入-cyj
 */
export function importAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/opportunityBid/importOpportunityBid',
        method: 'post',
        data
    });
};
